<template>
    <div class="occultation-list">
        <el-switch
            class="form-export-switch"
            v-model="filterExport"
            active-text="Filter export"
            inactive-text="No filters on export"
            :inactive-value="false"
            :active-value="true"
            @change="changedSwitchValue"
        >
        </el-switch>
        <el-form
            v-if="filterExport"
            class="gcmcn-card form-occultation"
            ref="form"
            :model="form"
        >
            <div class="flex-basis-6" style="margin-right: 15px;">
                <el-form-item class="gcmcn-form-input" prop="start_date">
                    <div class="gcmcn-form-label">Start date</div>
                    <el-date-picker
                        v-model="form.start_date"
                        popper-class="gcmcn-popper"
                        type="date"
                        size="mini"
                        placeholder="Select a date"
                    >
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="flex-basis-6" style="margin-right: 15px;">
                <el-form-item class="gcmcn-form-input" prop="end_date">
                    <div class="gcmcn-form-label">End date</div>
                    <el-date-picker
                        v-model="form.end_date"
                        popper-class="gcmcn-popper"
                        type="date"
                        size="mini"
                        placeholder="Select a date"
                        :pickerOptions="pickerOptions"
                    >
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="flex-basis-6">
                <el-form-item class="gcmcn-form-input" prop="start_time">
                    <div class="gcmcn-form-label">Taker</div>
                    <el-select
                        v-model="form.selectedTaker"
                        placeholder="Select"
                        size="mini"
                        popper-class="gcmcn-popper"
                        value-key="uid"
                    >
                        <el-option
                            v-for="taker in filteredBroadcastRights"
                            :key="taker.uid"
                            :label="taker.taker.name"
                            :value="taker">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <span class="el-button el-button--text btn-download-motor-file">
            <el-button
                type="primary"
                class="export-btn"
                @click="requestFile"
            >Download CSV</el-button>
        </span>
        <waiting-modal
            ref="waiting-modal"
            loading-text="Generating file"
            :onSuccess="downloadFile"
        ></waiting-modal>
    </div>
</template>

<script>
import moment from 'moment';
import WaitingModal from '@/components/partials/WaitingModal';
export default {
    components:{
        WaitingModal,
    },
    name: 'index',
    props:{
        channel:{
            type: Object,
            reqiured: true
        },
        filteredBroadcastRights: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            filterExport: false,
            form: {
                start_date: null,
                end_date: null,
                selectedTaker: '',
                start_time: '00:00:00',
                end_time: '23:59:00'
            },
        };
    },
    mounted(){
    },
    computed: {
        pickerOptions (){
            return {
                disabledDate: (time) => {
                    return time.getTime() < this.form.start_date;
                },
            };
        },
    },
    methods: {
        changedSwitchValue(){
            if(!this.filterExport) {
                this.form.start_date = null;
                this.form.end_date = null;
                this.form.selectedTaker = '';
            }
        },
        requestFile (){
            let taker = this.form.selectedTaker ? this.form.selectedTaker.taker.uid : '';
            this.$refs['waiting-modal'].open();
            let form = JSON.parse(JSON.stringify(this.form));
            if(form.start_date) {
                let startTimeSplitted = form.start_time.split(':');
                form.start_date = moment(form.start_date).set({
                    hours: startTimeSplitted[0],
                    minutes: startTimeSplitted[1],
                    seconds: startTimeSplitted[2],
                }).format('YYYY-MM-DDTHH:mm:ss');
                form.start_date = moment(form.start_date).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
            }
            if(form.end_date){
                let endTimeSplitted = form.end_time.split(':');
                form.end_date = moment(form.end_date).set({
                    hours: endTimeSplitted[0],
                    minutes: endTimeSplitted[1],
                    seconds: endTimeSplitted[2],
                }).format('YYYY-MM-DDTHH:mm:ss');
                form.end_date = moment(form.end_date).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
            }
            this.$store.dispatch('createItem', {
                item: {
                    start_date: form.start_date,
                    end_date: form.end_date,
                    status: 'PENDING',
                    taker_uid: taker,
                    channel_uid: this.channel.uid
                },
                model: 'BlankingExport',
                url: this.$store.state.api.meta.listModels.BlankingExport.url,
            }).then((res) => {
                this.$refs['waiting-modal'].watchRequestStatus(res.url);
            }).catch((e) => {
                this.$refs['waiting-modal'].displayError();
            },);
        },
        downloadFile (response) {
            var element = document.createElement('a');
            element.setAttribute('href', response.data.export_file);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
    }
};
</script>

<style lang="scss" scoped>
.occultation-list{
    padding: 3rem 2rem;
    border-radius: 5px;
    background: linear-gradient(180deg, #222222 0%, #111111 61.77%);
}
.filter-container{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.form-occultation{
    .el-switch__label:not(.is-active){
        color: #858d96;
    }
    .crop-rules{
        text-transform: initial;
        color: #bbb;
    }
    .gcmcn-danger-btn{
        margin-top: 20px;
        margin-bottom: 20px;
    }
}
.form-export-switch{
    margin-bottom: 1em;
    display: block;
}
.export-btn{
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/BlankingExport/index.vue